<template>
  <div class="quote-box">
    <div class="isTxt" v-if="isTxt">
      {{ name || '-' }}
    </div>
    <template v-else>
      <el-select
        v-model="innerValue"
        filterable
        remote
        class="custom-select"
        reserve-keyword
        remote-show-suffix
        :placeholder="renderConfig.placeholder"
        :remote-method="remoteMethod"
        :loading="loading"
        style="width: 100%"
        @change="changeValue"
        :suffix-icon="Search"
      >
        <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { Search } from '@element-plus/icons-vue'
import { computed, nextTick, onMounted, PropType, ref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { getQuoteValue } from '@/apis/objectManage'
import { isArray, isEmpty, isNullOrUndefOrEmpty, isString } from '@/utils/is'
import { fieldTypeConfig, fieldTypeEnum } from '@/enums/preObjectManage'
import {
  dealLabelValueConfig,
  dealQuoteValueConfig
} from '@/components/custom/form/components/utils'
import {
  getPageComponentData,
  getPageComponentDataEchoAcquire,
  getTagForEcho
} from '@/apis/customerManage'
import globalEnv from '@/configs'
import { isField, isSubList } from '@/utils/preObjectManage/utils'

const props = defineProps({
  ...basicProps,
  quoteMappingConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  index: {
    type: Number,
    default: 0
  },
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})
const name = ref('')
const loading = ref(false)
const allListValue = ref<Recordable[]>([])

const emit = defineEmits(['update:modelValue', 'refreshDataList', 'refreshSubListRowDataId'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

const list = ref<Recordable[]>([])

// 该状态决定是否根据其他引用或者映射字段改变传递进来的list
const sendVisible = ref(false)
// let flag = ref(true)
onMounted(() => {
  props.renderConfig.fieldClass.subTableEventEmitter.on(
    `refreshMapping${props.data.columnQuoteInfo?.group}`,
    (field: Recordable, fn: Fn, arr: Recordable[], res: Recordable[], index: any) => {
      // 只执行field与当前字段相同的，所以要加判断
      if (props.data.fieldSerial === field.fieldSerial && props.index === index) {
        innerValue.value = fn()
        list.value = arr || []
        sendVisible.value = true
        allListValue.value = res
        console.log(innerValue.value, list, field, 'kkklllll')
        // if (flag.value) {
        //   flag.value = false
        //   relevanceOtherField()
        // }
      }
    }
  )
  // if (props.isTxt) {
  //   getName()
  // }
  getName()
})

// 正查
async function remoteMethod(query: string) {
  if (query && query !== ' ') {
    // 只有findField找得到字段，并且该字段有值才可以请求
    let conditionFlag = true
    // 找到该映射字段对应的引用字段
    const quoteField = props.quoteMappingConfig.quoteFieldList.find(
      item => item.columnQuoteInfo?.group === props.data.columnQuoteInfo?.group
    )
    const conditionInfo = quoteField?.columnQuoteInfo?.conditionInfo
      ? JSON.parse(JSON.stringify(quoteField.columnQuoteInfo.conditionInfo))
      : null
    if (conditionInfo && conditionInfo.conditionList) {
      // 长度最长是2，最多2个条件，conditionList
      conditionFlag = conditionInfo.conditionList.every((condis: Recordable) => {
        // 还要判断外部条件是and，还是or ， exteriorCondition
        // 还要判断内部条件是and，还是or , interiorCondition
        let flag = false // 当前这个外部条件是否为true的标识
        // 内部条件是否为true，还要取决于内部条件的AND还是OR
        if (condis.interiorCondition && condis.interiorCondition === 'AND') {
          flag = condis.conditions.every(condi => {
            const field = findField(condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          })
        } else {
          flag = condis.conditions.some(condi => {
            const field = findField(condi.rightColumnSerial)
            if (!isEmpty(field)) {
              return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
            } else {
              return true
            }
          })
        }
        return flag
      })
    }

    if (conditionFlag) {
      const { code } = props.data
      let queryVal = ''
      if (props.data.dataMark === 1) {
        // 要根据query去匹配columnDataList中的label，然后找到值
        // 模糊匹配
        // const curItem = props.data.columnDataList.find(item => item.label.)
        const strategyFn = dealQuoteValueConfig[code]
        if (strategyFn) {
          queryVal = strategyFn(props.data.columnDataList, query)
        }
      } else if (props.data.dataMark === 2) {
        // 已经查询过一次了
        if (props.data.renderConfig.dataList && props.data.renderConfig.dataList.length) {
          const strategyFn = dealQuoteValueConfig[code]
          if (strategyFn) {
            queryVal = strategyFn(props.data.renderConfig.dataList, query)
          }
        } else {
          // 调用接口之后再去匹配，然后找到对应的值，传递给后端
          const postData = {
            tableCode: props.data?.columnQuoteInfo?.sourceTableCode || props.data.tableCode,
            columnId: props.data.id,
            columnUseScene: props.data.columnUseScene
          }
          const res = await getPageComponentData(postData)
          emit('refreshDataList', res)
          const strategyFn = dealQuoteValueConfig[code]
          if (strategyFn) {
            queryVal = strategyFn(res, query)
          }
        }
      } else {
        queryVal = query
      }
      if (queryVal) {
        loading.value = true
        // group相同的引用字段和映射字段的集合
        const sameGroup = getGroupField(props.data.columnQuoteInfo?.group)
        const quoteColumnList = sameGroup.map(field => {
          return {
            columnSerial: field.columnSerial,
            quoteColumnSerial: field.columnQuoteInfo.quoteColumnSerial,
            unionQueryColumnSerials: field.columnQuoteInfo.unionQueryColumnSerials || '',
            queryValue: props.data.fieldSerial === field.fieldSerial ? queryVal.split(',') : [], // 只有输入的当前字段才有值
            quoteModuleGroup: field.columnQuoteInfo.quoteModuleGroup || ''
          }
        })

        const conditionInfo = quoteField?.columnQuoteInfo?.conditionInfo
          ? JSON.parse(JSON.stringify(quoteField.columnQuoteInfo.conditionInfo))
          : null
        if (conditionInfo && conditionInfo.conditionList) {
          conditionInfo.conditionList.forEach((condis: Recordable) => {
            condis.conditions.forEach((condi: Recordable) => {
              // 如何去拿当前条件对应基础字段对应的值
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                if (!isNullOrUndefOrEmpty(props.formData[field.fieldCode])) {
                  let val = !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
                    ? isArray(props.formData[field.fieldCode])
                      ? props.formData[field.fieldCode].join(',')
                      : String(props.formData[field.fieldCode])
                    : ''
                  // 比较值，再确定用哪一个
                  const sensitiveValues = props.subFieldFormData?.sensitiveValues
                  if (sensitiveValues) {
                    const hyposensitization = sensitiveValues[field.fieldCode]
                    if (hyposensitization) {
                      val =
                        hyposensitization.sensitiveValue === val
                          ? hyposensitization.originalValue
                          : val
                    }
                  }
                  condi.rightValue = JSON.stringify(val.split(','))
                }
              }
            })
          })
        }
        const postData = {
          quoteTableCode: props.data.columnQuoteInfo.quoteTableCode, // 关联表单序列号
          quoteColumnList,
          conditionInfo,
          alert: props.data.columnQuoteInfo.alert || false,
          tableCode: props.data.columnQuoteInfo.tableCode
        }
        const res = await getQuoteValue(postData)
        allListValue.value = res
        loading.value = false
        // 根据当前子表字段，怎么取出他所在的主数据，然后再取出该子表所有的数据
        // props.data.columnQuoteInfo.quoteModuleGroup
        // 取出所有数据中，等于quoteModuleGroup下的所有子表的数据，然后再去处理当前字段的下拉
        const arr123: Recordable[] = []
        res?.forEach(item => {
          const key = Object.keys(item).find(
            key => key === props.data.columnQuoteInfo.quoteModuleGroup
          )
          if (key) {
            item[key].forEach(g => {
              arr123.push(g)
            })
          }
        })
        const dealData: Recordable[] = getDealData(props.data, arr123)
        console.log(dealData, 'dealData000')
        list.value = await getEchoData(props.data, dealData)
        sendVisible.value = false
      }
    }
  }
}

const currentObj = ref<Recordable>({})
function getCurrentObj(id: string) {
  const current = allListValue.value.find(item => item.id === id)
  if (current) {
    currentObj.value = current
  }
}

// 修改值
function changeValue(value: any) {
  // 取出当前选择的数据所在的对象
  const current = list.value.find(item => item.value === value)
  if (current) {
    getCurrentObj(current.data_id)
    // eslint-disable-next-line vue/no-mutating-props
    emit('refreshSubListRowDataId', {
      index: props.index,
      quoteDataId: current.id
    })
  }
  nextTick(() => {
    relateMappingField(val => () => val)
    relevanceOtherField()
  })
  // relateMappingField(val => () => val)
  // relevanceOtherField()
}
// 映射字段，且是子表字段，改值的时候，只会修改相同子表中其他子表字段的值
function relateMappingField(fn: Fn) {
  // 要给group相同的排除自己之后所有的映射字段赋值
  // 取出排除自己的所有映射字段(可能包含其他group的)
  const mappingFieldList = props.quoteMappingConfig.mappingFieldList.filter(
    item => item.fieldSerial !== props.data.fieldSerial
  )

  let relateMappingFields: Recordable[] = []
  // 取出与当前引用字段的group相同的映射字段，并且还要是在一个子表中的字段
  mappingFieldList.forEach((i: Recordable) => {
    if (
      i.columnQuoteInfo.group === props.data.columnQuoteInfo.group &&
      i.columnQuoteInfo.quoteModuleGroup === props.data.columnQuoteInfo.quoteModuleGroup
    ) {
      relateMappingFields.push({ ...i })
    }
  })
  // 这是处理同子表中的其他映射字段的值
  dealValAndChangeTable(relateMappingFields, fn)

  // 还要处理该子表映射字段对应的该组的其他映射主字段和其他映射子表字段和引用字段

  // 1.处理其他映射主字段
  let relateMappingFields1: Recordable[] = []
  // 取出与当前引用字段的group相同的映射字段，排除该字段相同的子表的其他字段，并且是主字段，结果就是有主字段
  mappingFieldList.forEach((i: Recordable) => {
    if (
      i.columnQuoteInfo.group === props.data.columnQuoteInfo.group &&
      isField(i.columnQuoteInfo.quoteFieldType) &&
      i.columnQuoteInfo.quoteModuleGroup !== props.data.columnQuoteInfo.quoteModuleGroup
    ) {
      relateMappingFields1.push({ ...i })
    }
  })
  // 这是处理其他映射主字段
  dealValAndChange(relateMappingFields1, fn, false)

  // 2.处理其他映射子表字段
  let relateMappingFields2: Recordable[] = []
  // 取出与当前引用字段的group相同的映射字段，排除该字段相同的子表的其他字段，并且是子表字段，结果就是子表字段
  mappingFieldList.forEach((i: Recordable) => {
    if (
      i.columnQuoteInfo.group === props.data.columnQuoteInfo.group &&
      isSubList(i.columnQuoteInfo.quoteFieldType) &&
      i.columnQuoteInfo.quoteModuleGroup !== props.data.columnQuoteInfo.quoteModuleGroup
    ) {
      relateMappingFields2.push({ ...i })
    }
  })
  // 这是处理其他映射主字段
  dealValAndChange(relateMappingFields2, fn, true)

  // 3.处理当前子表字段同group的引用字段
  const quoteFieldList = props.quoteMappingConfig.quoteFieldList
  const relateQuoteFields3: Recordable[] = []
  // 取出与当前映射字段的group相同的引用字段
  quoteFieldList.forEach((i: Recordable) => {
    if (i.columnQuoteInfo.group === props.data.columnQuoteInfo.group) {
      relateQuoteFields3.push({ ...i })
    }
  })
  // 取出的引用字段可能是主表字段也可能是子表字段
  // 取出主表字段
  const relateQuoteFields1 = relateQuoteFields3.filter(item =>
    isField(item.columnQuoteInfo.quoteFieldType)
  )
  dealQuoteValAndChange(relateQuoteFields1, fn, false)
  // 取出子表映射字段
  const relateQuoteFields2 = relateQuoteFields3.filter(item =>
    isSubList(item.columnQuoteInfo.quoteFieldType)
  )
  dealQuoteValAndChange(relateQuoteFields2, fn, true)
}

// 处理引用字段值并回显
function dealQuoteValAndChange(relateQuoteFields: Recordable[], fn: Fn, isSubList: boolean) {
  if (relateQuoteFields.length > 0) {
    relateQuoteFields.forEach(async field => {
      let arr: Recordable[] = []
      // 拿到处理后的主表的数据和子表的数据
      const dealData: Recordable[] = isSubList
        ? getDealTableFieldData(field, allListValue.value)
        : getDealData(field, allListValue.value)
      let subListData: Recordable[] = []
      if (isSubList) {
        subListData = getTableFieldData(field, allListValue.value) || []
      }
      const obj = isSubList ? subListData[0] : currentObj.value
      arr = await getEchoData(field, dealData)
      if (obj) {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshQuote${props.data.columnQuoteInfo?.group}`,
          field,
          fn &&
            fn(
              obj.id +
                globalEnv.specialQuoteFlag +
                (obj[field.fieldSerial] === null || !isNullOrUndefOrEmpty(obj[field.fieldSerial])
                  ? obj[field.fieldSerial]
                  : '')
            ),
          arr,
          allListValue.value,
          props.index
        )
      } else {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshQuote${props.data.columnQuoteInfo?.group}`,
          field,
          fn && fn(''),
          arr,
          allListValue.value,
          props.index
        )
      }
    })
  }
}

// 处理映射字段值并回显
function dealValAndChange(relateMappingFields: Recordable[], fn: Fn, isSubList: boolean) {
  console.log(relateMappingFields, 'relateMappingFields000')
  if (relateMappingFields.length > 0) {
    relateMappingFields.forEach(async field => {
      let arr: Recordable[] = []
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      // 拿到处理后的主表的数据和子表的数据
      const dealData: Recordable[] = isSubList
        ? getDealTableFieldData(field, allListValue.value)
        : getDealData(field, allListValue.value)
      console.log(dealData, 'dealData000')
      let subListData: Recordable[] = []
      if (isSubList) {
        subListData = getTableFieldData(field, allListValue.value) || []
      }
      console.log(subListData, 'subListData000')
      const obj = isSubList ? subListData[0] : currentObj.value
      arr = await getEchoData(field, dealData)
      console.log(arr, 'arr000')
      if (obj) {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn &&
            fn(
              obj.id +
                globalEnv.specialQuoteFlag +
                (obj[field.fieldSerial] === null || !isNullOrUndefOrEmpty(obj[field.fieldSerial])
                  ? obj[field.fieldSerial]
                  : '')
            ),
          arr,
          allListValue.value,
          props.index
        )
      } else {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn && fn(''),
          arr,
          allListValue.value,
          props.index
        )
      }
    })
  }
}

// 处理相同子表中其他映射字段
function dealValAndChangeTable(relateMappingFields: Recordable[], fn: Fn) {
  if (relateMappingFields.length > 0) {
    relateMappingFields.forEach(async field => {
      let arr: Recordable[] = []
      const dealData: Recordable[] = getDealTableFieldData(field, allListValue.value)
      arr = await getEchoData(field, dealData)
      // 取哪条数据的值做回显，要根据已选的这个子表字段的值
      const currentTableData = list.value.find(item => item.value === innerValue.value)
      const currentModuleGroupData = allListValue.value.find(
        item => item.id === currentTableData?.data_id
      )
      if (currentModuleGroupData) {
        const obj = currentModuleGroupData[field.columnQuoteInfo.quoteModuleGroup]?.find(
          item => item.id === currentTableData?.id
        )
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn &&
            fn(
              obj.id +
                globalEnv.specialQuoteFlag +
                (obj[field.fieldSerial] === null || !isNullOrUndefOrEmpty(obj[field.fieldSerial])
                  ? obj[field.fieldSerial]
                  : '')
            ),
          arr,
          allListValue.value,
          props.index
        )
      } else {
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshMapping${props.data.columnQuoteInfo?.group}`,
          field,
          fn && fn(''),
          arr,
          allListValue.value,
          props.index
        )
      }
    })
  }
}

// 抽离-处理数据
function getDealData(field: Recordable, list: Recordable[]) {
  console.log(list, 'list666')
  let newArr: Recordable[] = []
  list.forEach(item => {
    // 取出当前主表
    const key = Object.keys(item).find(key => key === field.fieldSerial)
    const key1 = Object.keys(item).find(key => key === `D${field.fieldSerial}`)
    if (key) {
      const val = item[key]
      newArr.push({
        label: val,
        value: item.id + globalEnv.specialQuoteFlag + val,
        id: item.id,
        postVal: val,
        data_id: item.data_id,
        showLabel: key1 ? item[key1] : val
      })
    } else {
      // 后端没有根据要查询的映射字段key
      newArr.push({
        label: '-',
        value: item.id + globalEnv.specialQuoteFlag,
        id: item.id,
        postVal: '',
        data_id: item.data_id,
        showLabel: key1 ? item[key1] : ''
      })
    }
  })
  return newArr
}
// 抽离-获取子表数据
function getTableFieldData(field: Recordable, arr: Recordable[]) {
  const current = list.value.find(item => item.value === innerValue.value)
  const currentData = arr.find(item => item.id === current?.data_id)
  return currentData ? currentData[field.columnQuoteInfo.quoteModuleGroup] : []
}
// 抽离-处理子表数据
function getDealTableFieldData(field: Recordable, list: Recordable[]) {
  const arr = getTableFieldData(field, list) || []
  return getDealData(field, arr)
}

// 抽离-根据数据进行回显的处理
async function getEchoData(field: Recordable, dealData: Recordable[]) {
  let arr: Recordable[] = []
  if (field.dataMark === 2) {
    if (dealData.length) {
      const echoArr = dealData.filter(item => !isNullOrUndefOrEmpty(item.postVal))
      // 否则接口要报错
      if (echoArr.length) {
        const postData = {
          columnId: field.id,
          echoData: echoArr.map(item => item.postVal).join(',')
        }
        let echoDataRes: Recordable[] = []
        if (field.code === fieldTypeConfig.tags) {
          const echoData = echoArr.map(item => {
            return JSON.parse(
              isString(item.postVal)
                ? item.postVal
                : item.postVal.replace(/\d+/g, match => `"${match}"`)
            ).join(',')
          })
          echoDataRes = await getTagForEcho({
            ...postData,
            echoData: echoData.join(',')
          })
        } else {
          echoDataRes = await getPageComponentDataEchoAcquire({ ...postData })
        }
        arr = dealData.map(item => {
          let label = item?.label || item?.showLabel || ''
          const strategyFn = dealLabelValueConfig[field.code]
          if (strategyFn) {
            label = strategyFn(echoDataRes, String(item.postVal), field)
          }
          return {
            ...item,
            label: label || '-'
          }
        })
      } else {
        arr = dealData.map(item => {
          return {
            ...item,
            label: '-'
          }
        })
      }
    }
  } else {
    arr = dealData.map(item => {
      let label = item?.label || item?.showLabel || ''
      if (!isNullOrUndefOrEmpty(item.postVal)) {
        const strategyFn = dealLabelValueConfig[field.code]
        if (strategyFn) {
          label = strategyFn(field?.columnDataList || [], String(item.postVal), field)
        } else {
          label = item.showLabel
        }
      }
      return {
        ...item,
        label: label || item.postVal || '-'
      }
    })
  }
  return arr
}

// 修改与当前组关联的其他组的信息
function relevanceOtherField() {
  // 去查询关联得其他组，并做回显
  // relevanceQuoteList：其他组引用字段
  // flag.value = false
  const { relevanceQuoteList, relevanceFieldSerials } = relevanceFn()
  if (relevanceQuoteList.length) {
    relevanceQuoteList.forEach(async (quote: Recordable, index: any) => {
      // 只有findField找得到字段，并且该字段有值才可以请求
      let conditionFlag = true
      // 要处理对应条件中rightValue的值
      const conditionInfo = quote.columnQuoteInfo.conditionInfo
        ? JSON.parse(JSON.stringify(quote.columnQuoteInfo.conditionInfo))
        : null
      if (conditionInfo && conditionInfo.conditionList) {
        // 长度最长是2，最多2个条件，conditionList
        conditionFlag = conditionInfo.conditionList.every((condis: Recordable) => {
          // 还要判断外部条件是and，还是or ， exteriorCondition
          // 还要判断内部条件是and，还是or , interiorCondition
          let flag = false // 当前这个外部条件是否为true的标识
          // 内部条件是否为true，还要取决于内部条件的AND还是OR
          if (condis.interiorCondition && condis.interiorCondition === 'AND') {
            flag = condis.conditions.every(condi => {
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
              } else {
                return true
              }
            })
          } else {
            flag = condis.conditions.some(condi => {
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                return !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
              } else {
                return true
              }
            })
          }
          return flag
        })
      }
      if (conditionFlag) {
        const { code } = quote
        // group相同的引用字段和映射字段的集合
        const sameGroup = getGroupField(quote.columnQuoteInfo.group)
        // 拿到当前引用字段，去调接口，拿到该组的所有数据，分别去触发引用字段和映射字段的回显
        const quoteColumnList = sameGroup.map(field => {
          return {
            columnSerial: field.columnSerial,
            quoteColumnSerial: field.columnQuoteInfo.quoteColumnSerial,
            unionQueryColumnSerials: field.columnQuoteInfo.unionQueryColumnSerials || '',
            queryValue: currentObj.value[field.fieldSerial]
              ? currentObj.value[field.fieldSerial].split(',')
              : [],
            quoteModuleGroup: field.columnQuoteInfo.quoteModuleGroup || ''
          }
        })
        // 要处理对应条件中rightValue的值
        const conditionInfo = quote.columnQuoteInfo.conditionInfo
          ? JSON.parse(JSON.stringify(quote.columnQuoteInfo.conditionInfo))
          : null
        if (conditionInfo && conditionInfo.conditionList) {
          conditionInfo.conditionList.forEach((condis: Recordable) => {
            condis.conditions.forEach((condi: Recordable) => {
              // 如何去拿当前条件对应基础字段对应的值
              const field = findField(condi.rightColumnSerial)
              if (!isEmpty(field)) {
                let val = !isNullOrUndefOrEmpty(props.formData[field.fieldCode])
                  ? isArray(props.formData[field.fieldCode])
                    ? props.formData[field.fieldCode].join(',')
                    : String(props.formData[field.fieldCode])
                  : ''
                // 比较值，再确定用哪一个
                const sensitiveValues = props.subFieldFormData?.sensitiveValues
                if (sensitiveValues) {
                  const hyposensitization = sensitiveValues[field.fieldCode]
                  if (hyposensitization) {
                    val =
                      hyposensitization.sensitiveValue === val
                        ? hyposensitization.originalValue
                        : val
                  }
                }
                condi.rightValue = JSON.stringify(val.split(','))
              } else {
                condi.rightValue = currentObj.value[condi.rightColumnSerial]
                  ? isString(currentObj.value[condi.rightColumnSerial])
                    ? JSON.stringify(currentObj.value[condi.rightColumnSerial].split(','))
                    : currentObj.value[condi.rightColumnSerial]
                  : JSON.stringify([])
              }
            })
          })
        }
        const postData = {
          quoteTableCode: quote.columnQuoteInfo.quoteTableCode, // 关联表单序列号
          quoteColumnList,
          conditionInfo,
          alert: quote.columnQuoteInfo.alert || false,
          tableCode: quote.columnQuoteInfo.tableCode
        }
        const res = await getQuoteValue(postData)
        // 获取到当前引用字段对应的所有映射字段-也要区分主表字段和子表字段
        await relateMappingFieldOther(quote, res) // -主表
        await relateMappingTableFieldOther(quote, res) // -子表

        // 处理引用字段的值-也要区分该引用字段是主表字段还是子表字段
        let arr: Recordable[] = []
        const dealData = getDealData(quote, res)
        arr = await getEchoData(quote, dealData)
        const fn = (val: any) => () => val
        props.renderConfig.fieldClass.subTableEventEmitter.emit(
          `refreshQuote${quote.columnQuoteInfo?.group}`,
          quote,
          fn && fn(arr?.[0]?.value),
          arr,
          res,
          isSubList(quote.fieldType) ? 0 : arr?.[0]?.id // 当前引用字段可能也是子表中的字段，也可能是分栏中的字段
        )
      }
    })
  }
}

// 处理其他组映射字段的值-主表
async function relateMappingFieldOther(quote: Recordable, res: Recordable[]) {
  // 取出主表映射字段
  const relateMappingFields = getMappingFieldList(quote.columnQuoteInfo.group).filter(item =>
    isField(item.columnQuoteInfo.quoteFieldType)
  )
  // 处理映射字段的值
  await dealValAndChangeOther(relateMappingFields, res, false)
}
// 处理其他组映射字段的值-子表
async function relateMappingTableFieldOther(quote: Recordable, res: Recordable[]) {
  // 取出主表映射字段
  const relateMappingFields = getMappingFieldList(quote.columnQuoteInfo.group).filter(item =>
    isSubList(item.columnQuoteInfo.quoteFieldType)
  )
  // 处理映射字段的值
  await dealValAndChangeOther(relateMappingFields, res, true)
}

// 处理字段值并回显-other
async function dealValAndChangeOther(
  relateMappingFields: Recordable[],
  res: Recordable[],
  isSubListBool: boolean
) {
  if (relateMappingFields.length > 0) {
    for (const field of relateMappingFields) {
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      let arr: Recordable[] = []
      // 不仅要刷新映射字段对应的值，而且还要传递映射字段的下拉数据，如果映射字段的下拉有多个，那映射字段对应的值取第一个
      // 拿到处理后的主表的数据和子表的数据
      const dealData: Recordable[] = isSubListBool
        ? getDealTableFieldData(field, res)
        : getDealData(field, res)
      let subListData: Recordable[] = []
      if (isSubListBool) {
        subListData = getTableFieldData(field, allListValue.value) || []
      }
      const obj = isSubListBool ? subListData[0] : currentObj.value
      arr = await getEchoData(field, dealData)
      const fn = (val: any) => () => val
      // 触发刷新当前引用字段对应的映射字段的值
      props.renderConfig.fieldClass.subTableEventEmitter.emit(
        `refreshMapping${field.columnQuoteInfo.group}`,
        field,
        fn && fn(arr?.[0]?.value),
        arr,
        res,
        isSubList(field.fieldType) ? 0 : arr?.[0]?.id // 当前引用字段可能也是子表中的字段，也可能是分栏中的字段
      )
    }
  }
}

// 取出与当前引用字段的group相同的映射字段
function getMappingFieldList(group: string) {
  // 要给group相同的所有的映射字段赋值
  const mappingFieldList = props.quoteMappingConfig.mappingFieldList
  const relateMappingFields: Recordable[] = []
  // 取出与当前引用字段的group相同的映射字段
  mappingFieldList.forEach(i => {
    if (i.columnQuoteInfo.group === group) {
      relateMappingFields.push({ ...i })
    }
  })
  return relateMappingFields
}

// 根据当前引用或者映射字段，找到group相同的一组字段
function getGroupField(group: string) {
  const sameGroup: Recordable[] = []
  props.positions.forEach(container => {
    if (container.code === 'TABLE') {
      container.children.forEach((child: Recordable) => {
        child.modules.forEach((module: Recordable) => {
          module.componentList.forEach((field: Recordable) => {
            if (field?.columnQuoteInfo?.group === group) {
              sameGroup.push({ ...field })
            }
          })
        })
      })
    }
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (field?.columnQuoteInfo?.group === group) {
            sameGroup.push({ ...field })
          }
        })
      })
    }
  })
  return sameGroup
}
// 通过当前组去匹配其他组是否有关联
function relevanceFn() {
  // 有关联的其他组的引用字段数据组
  const relevanceQuoteList: Recordable[] = []
  // 匹配成功的fieldSerial
  const relevanceFieldSerials: string[] = []
  // 当前组的映射字段
  const relateMappingFields = getMappingFieldList(props.data.columnQuoteInfo.group)
  // 要找到当前映射字段对应的引用字段
  const currentQuote = getCurrentQuoteField(props.data.columnQuoteInfo.group)
  // 排除当前引用字段之后剩余的其他引用字段,
  const quoteFieldList = props.quoteMappingConfig.quoteFieldList.filter(
    (item: Recordable) => item.fieldSerial !== currentQuote.fieldSerial
  )
  quoteFieldList.forEach(item => {
    const columnQuoteInfo = item.columnQuoteInfo
    // 正查
    if (
      columnQuoteInfo &&
      columnQuoteInfo.conditionInfo &&
      columnQuoteInfo.conditionInfo.conditionList &&
      columnQuoteInfo.conditionInfo.conditionList.length
    ) {
      columnQuoteInfo.conditionInfo.conditionList.forEach(condition => {
        condition.conditions.forEach(condi => {
          // 当前引用字段是否和条件匹配
          if (currentQuote.fieldSerial === condi.rightColumnSerial) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(condi.rightColumnSerial)
            }
            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
          // 当前其他映射字段是否和条件匹配
          const current = relateMappingFields.find(
            mapping => mapping.fieldSerial === condi.rightColumnSerial
          )
          if (current) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(condi.rightColumnSerial)
            }
            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
        })
      })
    }
    // 反查，根据当前编辑的映射字段找到对应的引用字段的条件去查抄其他group组字段相关
    const currentColumnQuoteInfo = currentQuote.columnQuoteInfo
    if (
      currentColumnQuoteInfo &&
      currentColumnQuoteInfo.conditionInfo &&
      currentColumnQuoteInfo.conditionInfo.conditionList &&
      currentColumnQuoteInfo.conditionInfo.conditionList.length
    ) {
      // 这是当前编辑的引用字段的条件
      currentColumnQuoteInfo.conditionInfo.conditionList.forEach(condition => {
        condition.conditions.forEach(condi => {
          // 根据当前条件去匹配其他group的字段的fieldSerial
          // 这是其他group对应的映射字段list
          const otherMappingList = getMappingFieldList(item.columnQuoteInfo.group)
          const current = otherMappingList.find(
            mapping => mapping.fieldSerial === condi.rightColumnSerial
          )
          if (current) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(current.fieldSerial)
            }

            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
          // 其他group的引用字段. item就是其他引用字段
          if (condi.rightColumnSerial === item.fieldSerial) {
            const fieldSerialIndex = relevanceFieldSerials.findIndex(
              fieldSerial => fieldSerial === condi.rightColumnSerial
            )
            if (fieldSerialIndex === -1) {
              relevanceFieldSerials.push(item.fieldSerial)
            }

            const relevanceIndex = relevanceQuoteList.findIndex(
              relevance => relevance.fieldSerial === item.fieldSerial
            )
            if (relevanceIndex === -1) {
              relevanceQuoteList.push(item)
            }
          }
        })
      })
    }
  })
  return { relevanceQuoteList, relevanceFieldSerials }
}

// 根据当前映射字段的group，去找到该group对应的引用字段
function getCurrentQuoteField(group: string) {
  return props.quoteMappingConfig.quoteFieldList.find(
    (quote: Recordable) => quote.columnQuoteInfo.group === group
  )
}

// 根据传入的serial去找到对应的字段，该字段必须是普通字段
function findField(columnSerial: string): Recordable {
  let obj: Recordable = {}
  props.positions.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (
            field.fieldSerial === columnSerial &&
            field.fieldType !== fieldTypeEnum.SYS_QUOTE &&
            field.fieldType !== fieldTypeEnum.CUSTOM_QUOTE &&
            field.fieldType !== fieldTypeEnum.SYS_MAPPING &&
            field.fieldType !== fieldTypeEnum.CUSTOM_MAPPING &&
            field.fieldType !== fieldTypeEnum.SON_SYS_QUOTE &&
            field.fieldType !== fieldTypeEnum.SON_CUSTOM_QUOTE &&
            field.fieldType !== fieldTypeEnum.SON_SYS_MAPPING &&
            field.fieldType !== fieldTypeEnum.SON_CUSTOM_MAPPING
          ) {
            obj = field
            return
          }
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach(child => {
        child.modules.forEach(module => {
          module.componentList.forEach((field: Recordable) => {
            if (
              field.fieldSerial === columnSerial &&
              field.fieldType !== fieldTypeEnum.SYS_QUOTE &&
              field.fieldType !== fieldTypeEnum.CUSTOM_QUOTE &&
              field.fieldType !== fieldTypeEnum.SYS_MAPPING &&
              field.fieldType !== fieldTypeEnum.CUSTOM_MAPPING &&
              field.fieldType !== fieldTypeEnum.SON_SYS_QUOTE &&
              field.fieldType !== fieldTypeEnum.SON_CUSTOM_QUOTE &&
              field.fieldType !== fieldTypeEnum.SON_SYS_MAPPING &&
              field.fieldType !== fieldTypeEnum.SON_CUSTOM_MAPPING
            ) {
              obj = field
              return
            }
          })
        })
      })
    }
  })
  return obj
}

async function getName() {
  const { code, dataMark, id } = props.data
  const val = isArray(innerValue.value)
    ? !isEmpty(innerValue.value)
      ? innerValue.value
      : ''
    : innerValue.value
  if (val) {
    if (dataMark === 2) {
      const postData = {
        columnId: id,
        echoData: isArray(innerValue.value) ? innerValue.value.join(',') : innerValue.value
      }
      let echoDataRes: Recordable[] = []
      if (code === fieldTypeConfig.tags) {
        const echoData = isString(innerValue.value)
          ? innerValue.value
          : innerValue.value.replace(/\d+/g, match => `"${match}"`)
        echoDataRes = await getTagForEcho({
          ...postData,
          echoData: JSON.parse(echoData).join(',')
        })
      } else {
        echoDataRes = await getPageComponentDataEchoAcquire({ ...postData })
      }
      let label = ''
      const strategyFn = dealLabelValueConfig[code]
      if (strategyFn) {
        label = strategyFn(echoDataRes, String(innerValue.value), props.data)
      }
      name.value = label || '-'
      list.value = [{ label: name.value, value: innerValue.value }]
    } else {
      let label = '-'
      const strategyFn = dealLabelValueConfig[code]
      if (strategyFn) {
        label = strategyFn(props.data?.columnDataList || [], String(innerValue.value), props.data)
      } else {
        const value = props.data.renderConfig.valCallback(innerValue.value, props.data)
        label = !isNullOrUndefOrEmpty(value) ? value : '-'
      }
      name.value = label
      list.value = [{ label: name.value, value: innerValue.value }]
    }
  } else {
    name.value = '-'
    // list.value = [{ label: name.value, value: innerValue.value }]
  }
}
watch(
  () => props.isTxt,
  val => {
    if (val) {
      getName()
    }
  }
)
</script>
<style lang="scss" scoped>
.quote-box {
  position: relative;
  width: 100%;
  .showDialogOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }
}
.custom-select {
  :deep(.is-reverse) {
    transform: none !important;
  }
}
</style>
